import SimplePage from "../components/site/SimplePage";

const sections = [
  {
    title: "Education",
    text: "Learning centers, mentorship programs, and scholarship support for students in underserved areas.",
    items: ["After-school tutoring", "Digital literacy labs", "Teacher training"]
  },
  {
    title: "Healthcare",
    text: "Mobile clinics and preventive care services that bring doctors closer to rural families.",
    items: ["Maternal health checkups", "Child nutrition monitoring", "Health camps"]
  },
  {
    title: "Livelihood",
    text: "Skill-building programs that create income opportunities and economic resilience.",
    items: ["Tailoring and crafts", "Micro-entrepreneurship", "Financial literacy"]
  }
];

function OurWork() {
  return (
    <SimplePage
      title="Our Work"
      lead="We focus on education, healthcare, and sustainable livelihoods that lift entire communities."
      sections={sections}
    />
  );
}

export default OurWork;
